import React, { useState, useEffect } from "react";

// Assets
import "~/assets/sass/pages/common/settingPage/settingPage.scss";
import "~/assets/sass/pages/common/settingPage/Modal/settingModal.scss";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";

const ProcessThree = ({ categories, doSetting, handleDoSetting, setWeight, handleWeight }) => {
	const { t } = useTranslation();
	const [sum, setSum] = useState(0);

	useEffect(() => {
		let weight = 0;
		categories.map((d) => (weight += parseInt(d.weight)));
		setSum(weight);
	}, [categories]);

	return (
		<>
			<div className="side-content">
				<h3>
					{t(
						"pages.investment.InvestSettingPage.processingModal.contents.ProcessThree.title"
					)}
					<span>
						(
						{t(
							"pages.investment.InvestSettingPage.processingModal.contents.ProcessThree.option"
						)}
						)
					</span>
					<label className="switch">
						<input type="checkbox" checked={doSetting} onChange={handleDoSetting} />
						<span className="slider round" />
						<span className="slider-label no-setting">
							{!doSetting
								? t(
										"pages.investment.InvestSettingPage.processingModal.contents.ProcessThree.status01"
								  )
								: t(
										"pages.investment.InvestSettingPage.processingModal.contents.ProcessThree.status02"
								  )}
						</span>
					</label>
				</h3>
			</div>
			<section className="c__card">
				<h3 className="step-title">
					{t(
						"pages.investment.InvestSettingPage.processingModal.contents.ProcessThree.stepTitle"
					)}
				</h3>
				<div className="weighting-wrap">
					<div className="c__form">
						{categories.map((d, index) => (
							<div
								className={`f__group ${doSetting ? "" : "no-setting"}`}
								key={d.idx}
							>
								<div className="f__label">{d.title}</div>
								<span className="divider" />
								<div className="f__control">
									<input
										type="text"
										className="c__input f__item"
										value={
											!doSetting ? (1 / categories.length) * 100 : d.weight
										}
										onChange={(e) => handleWeight(e.target.value, index)}
										disabled={!doSetting}
									/>
								</div>
							</div>
						))}

						{/* 카테고리 등록 없을 때*/}
						{/* <div className="f__group no-setting">
                        	<div className="f__label">test1 카테고리</div>
                        	<span className="divider" />
                        	<div className="f__control">
                        		<input
                        			type="text"
                        			className="c__input f__item"
                        			value="100"
                        			readOnly
                        		/>
                        	</div>
                        </div> */}
					</div>

					<div className="weighting-progress">
						<CircularProgressbar
							value={!doSetting ? 100 : sum}
							text={!doSetting ? "100%" : `${sum}%`}
							styles={buildStyles({ textColor: "#6B44FF", pathColor: "#6B44FF" })}
						/>
					</div>
				</div>
			</section>
		</>
	);
};

export default ProcessThree;
